export var CastBetTypes;
(function (CastBetTypes) {
    CastBetTypes["StraightForecast"] = "StraightForecast";
    CastBetTypes["ReverseForecast"] = "ReverseForecast";
    CastBetTypes["StraightTricast"] = "StraightTricast";
    CastBetTypes["CombinationForecast"] = "CombinationForecast";
    CastBetTypes["CombinationTricast"] = "CombinationTricast";
})(CastBetTypes || (CastBetTypes = {}));
//# sourceMappingURL=CastBetTypes.js.map